import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getAllEnviados = async ( params = {} ) => {

  const { 
    search, establecimiento, 
    page, pageSize, 
    doctor, especialidad, 
    modalidad
  } = params;


  const query = `
    query getAllLaboratoriosEnviados(
      $establecimiento : String!, 
      $search          : String,
      $especialidad    : String, 
      $modalidad       : String, 
      $page            : Int!, 
      $pageSize        : Int!,
      $desde           : Int, 
      $hasta           : Int,
      $mspfaltante     : String
    ) {
      allEstlaboratorio(
        busqueda        : $search, 
        establecimiento : $establecimiento, 
        especialidad    : $especialidad, 
        modalidad       : $modalidad, 
        page            : $page, 
        pageSize        : $pageSize,
        desde           : $desde, 
        hasta           : $hasta,
        mspfaltante     : $mspfaltante
      ) {
          laux{
            id
            token
            fechaCreacion
            estudiolab {
              id
              token
              fechaCreacion
              fechaProgramada
              modalidad{
                id
                descripcion
              }
              consultamedica{
                cita{
                  establecimiento{
                    id
                    Descripcion
                  }
                  paciente {
                    numHistoriaClinica
                    persona {
                      identificacion
                      primerNombre
                      segundoNombre
                      primerApellido
                      segundoApellido
                    }
                    segsalud{
                      descripcion
                    }
                  }
                  doctor{
                    idPersona{
                      primerNombre
                      segundoNombre
                      primerApellido
                      segundoApellido
                    }
                    especialidad{
                      descripcion
                    }
                  }
                }
              }
            }
            estadoHomologado
            laboratorio{
              codigo
              descripcion
              areaanalisis{
                descripcion
              }
            }
          }
          ls4{
              id
              token
              justificacion
              fechaCreacion

              auxiliarMuestras {
                id
                idPersona {
                  id
                  primerApellido
                  primerNombre
                }
              }
              estudiolab {
                id
                token
                fechaCreacion
                fechaProgramada
                modalidad{
                  id
                  descripcion
                }
                consultamedica{
                  cita{
                  id
                  cobSeleccionada {
                  id
                  descripcion}
                  fecderivacion
                  codderivacion
                  urlSolLabDer
                  urlsMspPaciente
                  urlsMspTitular1
                  urlsMspTitular2
                  urlsMspTitular3
                  urlDerivacion
                  urlCodigoDer

                    establecimiento{
                      id
                      Descripcion
                    }
                    paciente {
                      id
                      numHistoriaClinica
                      persona {
                        identificacion
                        primerNombre
                        segundoNombre
                        primerApellido
                        segundoApellido
                      }
                      segsalud{
                        descripcion
                      }
                    }
                    doctor{
                    id
                      idPersona{
                        primerNombre
                        segundoNombre
                        primerApellido
                        segundoApellido
                      }
                      especialidad{
                        descripcion
                      }
                    }
                  }
                }
              }
          numeroOrden
          estadoLab400
          idslaboratorios
          nordenEnterprise
          fechaResultado: fechaResultados
          urlInformeEnterprise
          urlMspCalificacion
          urlMspCalificacion1
          urlMspCalificacion2
          
        }
        total
        status
        message
        dataarchivo
      }
    }
  `;

  const variables = {
    search,
    page,
    pageSize,
    establecimiento,
    doctor,
    especialidad,
    modalidad,
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allEstlaboratorio;
    if( response2.status !== 'success' ) return null;

    const data = {
      labAux: response2.laux,
      labAs400: response2.ls4
    };

    return data;

  }catch(error){
    console.error('Error al traer los laboratorios enviados', error);
    return null;
  }
}

const getAllAS400 = async ( params = {} ) => {
  
  const { 
    search, establecimiento, 
    page, pageSize, 
    doctor, especialidad, 
    modalidad,
    fechaDesde, fechaHasta, excel
  } = params;

  const query = `
    query getAllLaboratoriosEnviados(
      $modalidad       : String, 
      $establecimiento : String!, 
      $search          : String,
      $doctor          : String,
      $especialidad    : String, 
      $page            : Int!, 
      $pageSize        : Int!,
      $mspfaltante     : String,
      $fechaDesde      : String,
      $fechaHasta      : String,
      $excel           : String
    ) {

      allEstlaboratorio(
        search          : $search, 
        establecimiento : $establecimiento, 
        especialidad    : $especialidad, 
        modalidad       : $modalidad,
        doctor          : $doctor,
        page            : $page, 
        pageSize        : $pageSize,
        mspfaltante     : $mspfaltante
        fechaDesde      : $fechaDesde,
        fechaHasta      : $fechaHasta,
        excel           : $excel
      ) {

        total
        status
        message
        dataarchivo

        ls4{
          id
          token
          justificacion
          fechaCreacion

          numeroOrden
          estadoLab400
          idslaboratorios
          nordenEnterprise
          fechaResultado: fechaResultados
          urlInformeEnterprise
          urlMspCalificacion
          urlMspCalificacion1
          urlMspCalificacion2

          auxiliarMuestras {
            id
            idPersona {
              id
              primerApellido
              primerNombre
            }
          }

          estudiolab {
            id
            token
            fechaCreacion
            fechaProgramada
            modalidad{
              id
              descripcion
            }
            consultamedica{
              cita{
                id
                cobSeleccionada {
                  id
                  descripcion
                }
                fechaCita
                horaCita
                fecderivacion
                codderivacion
                urlSolLabDer
                urlsMspPaciente
                urlsMspTitular1
                urlsMspTitular2
                urlsMspTitular3
                urlDerivacion
                urlCodigoDer

              establecimiento{
                id
                Descripcion
              }

              paciente {
                id
                numHistoriaClinica
                persona {
                  identificacion
                  primerNombre
                  segundoNombre
                  primerApellido
                  segundoApellido
                }
                segsalud{
                  descripcion
                }
              }
                doctor{
                id
                  idPersona{
                    primerNombre
                    segundoNombre
                    primerApellido
                    segundoApellido
                  }
                  especialidad{
                    descripcion
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    search,
    page,
    pageSize,
    establecimiento,
    doctor,
    especialidad,
    modalidad,
    fechaDesde,
    fechaHasta,
    excel
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    console.log('response laboratorios', response);

    if(response.status !== 200) return null;

    const response2 = response.data.data.allEstlaboratorio;
    if( response2.status !== 'success' ) return null;

    const data = {
      data: response2.ls4,
      dataarchivo : response.data.data.allEstlaboratorio.dataarchivo,
      total: response2.total
    }

    return data;

  }catch(error){
    console.error('Error al traer los laboratorios As400 enviados', error);
    return null;
  }
}

const getAllSns = async ( search = '' ) => {

  const query = `
    query AllLaboratoriosSns($search:String) {
      allLaboratoriosSns(search: $search) {
        total
        status
        message
        sns {
          id
          token
          codigo
          descripcion
          areaanalisis {
          id
          descripcion
          }
        }
      }
    }
  `;

  const variables = { search };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allLaboratoriosSns;
    if( response2.status !== 'success' ) return null;
    const data = response2.sns;

    const dataMap = data.map( item => {
      return {
        ...item,
        value: item.id,
        text: `${item.codigo} - ${item.descripcion}`,
        tipo: item.areaanalisis
      }
    });

    return dataMap;

  }catch(error){
    console.error('Error al traer los laboratorios sns', error);
    return null;
  }
}


const  searchMultiplesLaboratoriosById = async (ids) => {
  const query = `
    query MyQuery($ids : [ID]) {
      getLaboratorios(ids:$ids) {
        id
        codigo
        descripcion
      }
    }
  `;

  const variables = {
    ids
  }

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    const response2 = response.data.data.getLaboratorios;

    if (!response2) return null;
    
    return response2;

  } catch(error) {
    console.log("error buscarLaboratoriosIds", error);
    return null;
  }
}


const searchLaboratorios = async ( search, establecimiento, estado = '1' ) => {

  if(!search || !establecimiento) return null;

  const query = `
    query GetAllLabs(
      $estado         :String
      $establecimiento:ID
      $search         :String
    ) {
      getAllLabos(
        estado:$estado
        establecimiento:$establecimiento,
        search:$search
      ) {
        total
        status
        message
        laboratorio {
          id
          token
          codigo
          descripcion
        }
      }
    }
  `;

  const variables = {
    estado,
    establecimiento,
    search
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );
    if(response.status !== 200) return null;

    const response2 = response.data.data.getAllLabos;
    if( response2.status !== 'Success' ) return null;
    const data = response2.laboratorio;

    return data;
    
  }catch(error){
    console.error('Error al obtener el lab por codigo', error);
    return null
  }
}

export const laboratoriosService = {
  getAllSns,
  getAllEnviados,
  getAllAS400,

  searchMultiplesLaboratoriosById
};
